import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  button: {
    alignItems: 'center',
    borderRadius: '10px',
    display: 'inline-flex',
    height: theme.spacing(5.5),
    justifyContent: 'center',
    minWidth: theme.spacing(5.5),
    transition: 'background-color 0.15s linear, filter 0.15s linear',
    width: 'auto',
    '& svg': {
      height: 18,
      width: 18,
    },
    '&.Mui-disabled': {
      opacity: 0.5,
    },
  },
  content: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(0.75),
    minWidth: 0,
  },
  secondary: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
    backgroundImage: theme.palette.primaryGradient,
    color: theme.palette.common.white,
    '&:hover': {
      filter: 'brightness(0.90)',
    },
  },
}));
